<template>
    <div id="passwordHelpInline" class="card-text">
        <i class="bi bi-question-circle"></i> <span class="small">Le mot de passe doit contenir :</span>
        <ul class="small">
            <li>entre 12 et 30 caractères</li>
            <li>une minuscule</li>
            <li>une majuscule</li>
            <li>un chiffre</li>
            <li>un caractère spécial</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'PasswordHelp',
}
</script>
